import React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../../lib/utils';
import { Button } from '../Button';
const textAndCtaWrapperVariants = cva('flex flex-col xl:max-w-[448px] md:w-1/2 md:max-w-[386px] font-gotham', {
    variants: {
        layout: {
            left: 'items-start text-left justify-start',
            right: 'items-end text-right justify-end',
        },
    },
    defaultVariants: {
        layout: 'left',
    },
});
const dividerVariants = cva('h-0.5 w-[231px] bg-orange-500 mb-3 z-10', {
    variants: {
        layout: {
            left: 'md:ml-[-113px]',
            right: 'md:mr-[-113px]',
        },
    },
    defaultVariants: {
        layout: 'left',
    },
});
const mainContainerVariants = cva('flex flex-col items-center max-w-[992px] mx-auto md:flex-row', {
    variants: {
        layout: {
            left: 'md:flex-row md:justify-end',
            right: 'md:flex-row-reverse md:justify-start',
        },
    },
    defaultVariants: {
        layout: 'left',
    },
});
const imageBlockVariants = cva('flex items-center md:w-1/2 pb-6 md:pb-0', {
    variants: {
        layout: {
            left: 'justify-end xl:pr-11 md:pr-[30px]',
            right: 'justify-start xl:pl-11 md:pl-[30px]',
        },
    },
    defaultVariants: {
        layout: 'left',
    },
});
const ContentBlockWithImage = ({ image, title, subtitle, heading, content, ctaChildren, ctaAriaLabel, layout = 'left', }) => {
    return (React.createElement("div", { className: "py-10 px-6 md:px-[40px] md:py-[60px] xl:py-[50px] xl:px-10" },
        React.createElement("div", { className: cn(mainContainerVariants({ layout })) },
            React.createElement("div", { className: cn(imageBlockVariants({ layout })) }, image),
            React.createElement("div", { className: cn(textAndCtaWrapperVariants({ layout })) },
                title && (React.createElement("h3", { className: "text-sm text-brand-navy mb-3 font-medium" }, title.toUpperCase())),
                React.createElement("div", { role: "presentation", id: "divider", className: cn(dividerVariants({ layout })) }),
                subtitle && (React.createElement("h4", { className: "text-[40px] font-medium leading-none mb-6 md:mb-10 text-brand-navy" }, subtitle)),
                heading && (React.createElement("h2", { className: "text-[25px] md:text-[32px] font-medium mb-[14px] xl:mb-6 text-[#012A2D]" }, heading)),
                content && (React.createElement("p", { className: "mb-8 xl:mb-14 text-brand-navy font-normal tracking-tighter" }, content)),
                React.createElement(Button, { id: "cta-button", asChild: true, "aria-label": ctaAriaLabel || `Call to action for ${title}` }, ctaChildren)))));
};
export { ContentBlockWithImage };
